const STAGING_CX_TESTER = /cx-staging-.+hbdev.io/;
const STAGING_MX_TESTER =
    /hb-mx-staging-.+.(web.preview.stg-us-east-1-v7|web.e2e.stg-us-east-1-v7).hbdev.io/;
const STAGING_APP_TESTER =
    /hb-app-staging-.+.(web.preview.stg-us-east-1-v7|web.e2e.stg-us-east-1-v7).hbdev.io/;
const STAGING_CX_DOMAIN = 'cx-staging';
const STAGING_CX_API_DOMAIN = 'app-staging';

const STAGING_QA_API_BASE_URL = 'https://staging-qa-app.honeybook.com';

export function getStagingApiBaseUrl(): string {
    if (STAGING_MX_TESTER.test(window.location.href)) {
        return (
            'https://' +
            window.location.hostname
                .replace('hb-mx-staging-', 'hb-app-staging-')
                .replace('.web.', '.api.')
        );
    }
    if (STAGING_APP_TESTER.test(window.location.href)) {
        return 'https://' + window.location.hostname.replace('.web.', '.api.');
    }
    if (STAGING_CX_TESTER.test(window.location.href)) {
        return getStagingCXApiBaseUrl();
    } else {
        return getStagingQAApiBaseUrl();
    }
}

function getStagingCXApiBaseUrl(): string {
    let cxApiUrl = `${window.location.protocol}//${window.location.host.replace(
        STAGING_CX_DOMAIN,
        STAGING_CX_API_DOMAIN
    )}/`;

    return cxApiUrl.replace('.web.', '.api.');
}

function getStagingQAApiBaseUrl(): string {
    return STAGING_QA_API_BASE_URL;
}
